module.exports = __webpack_public_path__ + "img/visuels-campagne-full-gafam-22_slideshow-auto.50fc352e.png";